
const TimeFormat = (time) => {

        if (!time || time == "") return '';
        const [hour, minute] = time.split(':').map(Number);
        const period = hour >= 12 ? 'PM' : 'AM';
        const formattedHour = (hour % 12 || 12)?.toString()?.padStart(2, '0'); 
        return `${formattedHour}:${minute?.toString()?.padStart(2, '0')} ${period}`;
      }

const formatDateEST = (dateString) => {
  if (!dateString) return "";

  const date = new Date(dateString);
  if (isNaN(date.getTime())) return "";

  const options = {
    timeZone: "America/New_York",
    month: "2-digit",
    day: "2-digit",
    year: "numeric",
  };

  return new Intl.DateTimeFormat("en-US", options).format(date);
};

export { TimeFormat, formatDateEST };